import { Typography } from '@mui/material'

import { ModalWrapper, DeleteConfirmForm, HelperWrapper } from 'src/components'
import { useMe } from 'src/hooks'
import { EAccountRoles, ETranslationNs } from 'src/types'

import { useStyles } from './styles'

interface IDeleteConfirmModalProps {
  open: boolean
  handleClose: () => void
  handleDelete: () => void | Promise<void>
}

const DeleteConfirmModal = ({ open, handleClose, handleDelete }: IDeleteConfirmModalProps) => {
  const classes = useStyles()
  const { data: user } = useMe()

  const handleSubmit = async () => {
    await handleDelete()
  }

  const owningAccounts = user!.accounts.filter(({ roles }) => roles.includes(EAccountRoles.owner))

  return (
    <ModalWrapper className={classes.formWrapper} onClose={handleClose} open={open}>
      <div className={classes.sectionWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="user-profile-form-delete-title" ns={ETranslationNs.UserProfile} />
        </Typography>
        {!!owningAccounts.length ? (
          <div>
            <Typography className={classes.text}>
              <HelperWrapper t="user-profile-form-delete-warning" ns={ETranslationNs.UserProfile} />
              &nbsp;
              <b>{owningAccounts.map(({ account }) => account.account_holder).join(', ')}</b>
            </Typography>
            <br />
            <br />
            <Typography align="center" className={`${classes.text} ${classes.textAccent}`}>
              <b>
                <HelperWrapper
                  t="user-profile-form-delete-warning-1"
                  ns={ETranslationNs.UserProfile}
                />
              </b>
            </Typography>
          </div>
        ) : (
          <Typography align="center" className={classes.text}>
            <HelperWrapper t="user-profile-form-delete-approval" ns={ETranslationNs.UserProfile} />
            <br />{' '}
            <b>
              <HelperWrapper
                t="user-profile-form-delete-approval-1"
                ns={ETranslationNs.UserProfile}
              />
            </b>
          </Typography>
        )}
      </div>
      <DeleteConfirmForm disabled={!!owningAccounts.length} handleSubmit={handleSubmit} />
    </ModalWrapper>
  )
}

export { DeleteConfirmModal }
